namespace JupitersChoice {
    export class BigWinText extends Sapphire.Container {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('GameStage') _gameStage: Sapphire.GameStage;

        private _data: Sapphire.DataHelper;

        private _textSprite1: PIXI.Sprite;
        private _sheenSprite1: PIXI.Sprite;

        private _textContainer1: PIXI.Graphics;
        private _textContainer2: PIXI.Graphics;

        private _textSprite2: PIXI.Sprite;
        private _sheenSprite2: PIXI.Sprite;
        private _sheenMask: any;
        private _sheenTargetX: number = -1000;
        private _sheenInitX: number = -1000;

        private _currentFront:number = 2;

        constructor(){
            super();
        }

        construct(data: any): void{
            this._data = new Sapphire.DataHelper(data);

            this._textSprite1 = new PIXI.Sprite();
            this._textSprite2 = new PIXI.Sprite();
            this._sheenSprite1 = new PIXI.Sprite();
            this._sheenSprite2 = new PIXI.Sprite();

            this._textContainer1 = new PIXI.Graphics();
            this._textContainer2 = new PIXI.Graphics();

            this._textContainer1.addChild(this._textSprite1);
            this._textContainer1.addChild(this._sheenSprite1);
            this._textContainer2.addChild(this._textSprite2);
            this._textContainer2.addChild(this._sheenSprite2);

            this.addChild(this._textContainer1);
            this.addChild(this._textContainer2);
            this._textContainer1.visible = false;
            this._textContainer2.visible = false;

            if(this._gameStage.isWebGL){

                this._sheenMask = new PIXI.Sprite(PIXI.Texture.WHITE);

                this._sheenMask.width = 150;
                this._sheenMask.height = 1000;

                var gradientTexture: PIXI.Texture = this.createLinearGradient(1000, 800, {
                    0: 'black',
                    0.3: 'white',
                    0.7: 'white',
                    1: 'black',
                });
                this._sheenMask.texture = gradientTexture;
            }else{
                this._sheenMask = new PIXI.Graphics();
                this._sheenMask.beginFill();
                this._sheenMask.drawRect(0,0,this._data.get('sheenWidth',150),1000);
                this._sheenMask.endFill();
            }

            this._sheenMask.rotation = 0.5;
            this._sheenMask.pivot = new PIXI.Point(this._sheenMask.width/2,this._sheenMask.height/2);
            this._sheenMask.x = this._sheenInitX;

            this._sheenSprite1.mask = this._sheenMask;
            this._sheenSprite2.mask = this._sheenMask;
            this.addChild(this._sheenMask);

            this.updateLayout();
        }

        setOrientation(orientation: string): void {
            this._data.orientation = orientation;
            this.updateLayout();
        }

        private updateLayout(){
            this.x = this._data.get('x',this.x);
            this.y = this._data.get('y',this.y);
            
            var scale = this._data.get('scale',{x:1,y:1});
            this.scale.set(scale.x,scale.y);

            var pivot = this._data.get('pivot',{x:0,y:0});
            this.pivot = new PIXI.Point(this.width*pivot.x,this.height*pivot.x);
        }

        private createLinearGradient(width, height, stops): PIXI.Texture {

            var canvas = document.createElement('canvas');

            canvas.width = width;
            canvas.height = height;

            var ctx = canvas.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, width, 0);
            var stopPoints = Object.keys(stops);

            for (var i = 0, n = stopPoints.length; i < n; i += 1) {
                gradient.addColorStop(parseFloat(stopPoints[i]), stops[stopPoints[i]]);
            }

            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, width, height);

            return PIXI.Texture.fromCanvas(canvas);
        }

        init(level: string): void{
            this.switchSprite(level,false);
        }

        private performSwitch(container1: PIXI.Graphics,container2: PIXI.Graphics, animate: boolean, duration?: number) {
            //move it to the front.
            if(this.children.indexOf(container1) > this.children.indexOf(container2)){
                this.swapChildren(container1,container2);
            };
            container1.visible = true;
            container1.pivot = new PIXI.Point(container1.width / 2, container1.height / 2);
            container1.x = 0;
            container1.y = 0;

            this._sheenTargetX = Math.max(container1.width,container2.width)/2 + 200;
            this._sheenInitX = this._sheenTargetX*-1;
            if(animate){
                if(typeof duration == "undefined"){
                    duration = this._data.get('duration',1);
                }
                container1.scale.set(0,0);
                TweenMax.to(container1.scale,duration,{
                    x:1,
                    y:1,
                    ease:Quad.easeInOut
                });
                TweenMax.to(container2.scale,duration,{
                    x:0,
                    y:0,
                    ease:Quad.easeInOut,
                    onComplete: () => {
                        container2.visible = false;
                        container2.scale.set(1, 1);
                    }
                });
            }else{
                container2.visible = false;
            }
        }

        switchSprite(packName: string, animate: boolean = true, duration?: number){
            var textureInfo: string[] = this._data.get(packName+'Frames');
            if(this._currentFront == 2){
                this._textSprite1.texture = this._assetCache.getTexture(textureInfo[0][0],textureInfo[0][1],textureInfo[0][2]);
                this._sheenSprite1.texture = this._assetCache.getTexture(textureInfo[1][0],textureInfo[1][1],textureInfo[1][2]);
                this.performSwitch(this._textContainer1,this._textContainer2,animate,duration);
                this._currentFront = 1;
            }else{
                this._textSprite2.texture = this._assetCache.getTexture(textureInfo[0][0],textureInfo[0][1],textureInfo[0][2]);
                this._sheenSprite2.texture = this._assetCache.getTexture(textureInfo[1][0],textureInfo[1][1],textureInfo[1][2]);
                this.performSwitch(this._textContainer2,this._textContainer1,animate,duration);
                this._currentFront = 2;
            }
        }

        startSheen(){
            TweenMax.killTweensOf(this._sheenMask);

            this._sheenMask.x = this._sheenInitX;
            TweenMax.to(this._sheenMask,this._data.get('sheenDuration',2),{
                repeat:-1,
                repeatDelay:this._data.get('sheenInterval',3),
                x:this._sheenTargetX
            });
        }

        stopSheen(){
            TweenMax.killTweensOf(this._sheenMask);
        }

    }
}